import * as Keys from "../config/componentKeys";

import { transformData } from "../dataTransformation";
import { ENDPOINT_VIOLATIONS } from "../config";
import { authRequest } from "./auth";
import * as moment from "moment";

export const FETCH_VIOLATIONS_HISTORY = "FETCH_VIOLATIONS_HISTORY";
export const FETCH_VIOLATIONS_HISTORY_SUCCESS = "FETCH_VIOLATIONS_HISTORY_SUCCESS";
export const FETCH_VIOLATIONS_HISTORY_MESSAGE = "FETCH_VIOLATIONS_HISTORY_MESSAGE";
export const FETCH_VIOLATIONS_HISTORY_FAILURE = "FETCH_VIOLATIONS_HISTORY_FAILURE";

export function fetchViolationsHistory(fromTimestamp?: number, toTimestamp?: number, violationType?: string[], count?: number, page?: number) {
    return async (dispatch: Function, getState: Function) => {
        try {
            dispatch({
                type: FETCH_VIOLATIONS_HISTORY
            });

            if (!toTimestamp) {
                toTimestamp = moment().endOf('day').utc().valueOf();
            }
            if (!fromTimestamp) {
                fromTimestamp = moment().startOf('day').utc().valueOf();
            }
            if(!count){
                count = 100;
            }
            if(!page){
                page = 1;
            }

            const response = await dispatch(authRequest(ENDPOINT_VIOLATIONS(fromTimestamp, toTimestamp, violationType, count, page)));
             console.log(response);


            if (response && response.data && response.data.data && response.data.data.results) {
                const result = response.data.data.results;

                const data = transformData(result, Keys.VIOLATIONS);

                dispatch({
                    type: FETCH_VIOLATIONS_HISTORY_SUCCESS,
                    payload: data
                })

            } else {
                dispatch({
                    type: FETCH_VIOLATIONS_HISTORY_FAILURE,
                    payload: {
                        message: 'Could not get the correct response'
                    }
                })
            }

        } catch(error) {
            console.log(error);
            dispatch({
                type: FETCH_VIOLATIONS_HISTORY_FAILURE,
                payload: {
                    message: error
                }
            })

            // throw error
        }
    }
}

export const LOAD_VIOLATION_DETAIL = "LOAD_VIOLATION_DETAIL";
export const LOAD_VIOLATION_DETAIL_SUCCESS = "LOAD_VIOLATION_DETAIL_SUCCESS";
export const LOAD_VIOLATION_DETAIL_FAILURE = "LOAD_VIOLATION_DETAIL_FAILURE";

export function sendViolationDetail(itemId: string, detailType: string) {
    return async (dispatch: Function, getState: Function) => {
        try {

            // console.log(getState());

            if (itemId) {
                dispatch({
                    type: LOAD_VIOLATION_DETAIL
                });

                const state = getState();
                let violationsArray;

                if (detailType === 'recent') {
                    violationsArray = state.dashboard.recentViolations.recentViolationsArray
                } else {
                    violationsArray = state.violationHistory.violations.recentViolationsArray
                }

                let item;
                for (let i = 0; i < violationsArray.length; i++) {
                    item = violationsArray[i];
                    if (item.id === itemId) {
                        break;
                    }
                }

                if (item && item.violationDetail) {

                    dispatch({
                        type: LOAD_VIOLATION_DETAIL_SUCCESS,
                        payload: {
                            violation: item,
                            detailType
                        }
                    })

                } else {
                    dispatch({
                        type: LOAD_VIOLATION_DETAIL_FAILURE,
                        payload: {
                            message: 'Could not get the correct response'
                        }
                    })
                }
            } else {
                dispatch({
                    type: LOAD_VIOLATION_DETAIL_FAILURE
                })
            }

        } catch(error) {
            console.log(error);
            dispatch({
                type: LOAD_VIOLATION_DETAIL_FAILURE,
                payload: {
                    message: error
                }
            })

            // throw error
        }
    }
}

export const PAGE_CHANGED_TO_NEXT = "PAGE_CHANGED_TO_NEXT";
export const PAGE_CHANGED_TO_PREV = "PAGE_CHANGED_TO_PREV";

export function changePage(type: string) {
    return async (dispatch: Function, getState: Function) => {
        try {
            if(type === "PAGE_CHANGED_TO_NEXT"){
                dispatch({
                    type: PAGE_CHANGED_TO_NEXT,
                })
            }
            if (type === "PAGE_CHANGED_TO_PREV"){
                dispatch({
                    type: PAGE_CHANGED_TO_PREV,
                })
            }
        }
        catch (error){
            console.log(error);

        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/violationsHistory.ts